import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the step between the client and a diet plan after the tab the plan lives on: Adam Nowak > Diet > Plan. */
export const Route = createFileRoute("/(private)/trainees/$clientId/diet-plans")({
  loader: () => ({ crumb: m.client_tab_diet() }),
  component: Outlet,
});
